import React from 'react';

const CustomStepper = ({ steps, heading, onStepSelect, currentStepGroup, currentStep, selectedType }) => {

  return (
    <div className="w-full max-w-lg mx-auto text-center">

      <div className='text-2xl mb-8 text-lightPrimary dark:text-primary-gradient'>{heading || ""}</div>
      <div className={
        currentStepGroup === 1
          ? ""
          : "grid md:grid-cols-3 gap-4"
      }>
        {steps.map((step, index) => (
          <button
            key={index}
            className={`text-lg font-medium py-4 px-6 border rounded shadow-md ${((currentStepGroup === 1 && index === currentStep) || (currentStepGroup === 2 && index + 1 === selectedType.id)) ? 'bg-[radial-gradient(circle_at_10%_10%,rgb(237,237,237),#9e9e9e,#9e9e9e,#9e9e9e)] text-dark dark:button-primary-gradient dark:text-black border-dark hover:text-white' : 'border-dark dark:border-primary-gradient text-lightPrimary dark:text-primary-gradient hover:bg-[radial-gradient(circle_at_10%_10%,rgb(237,237,237),#9e9e9e,#9e9e9e,#9e9e9e)] text-dark hover:text-white dark:hover:button-primary-gradient dark:hover:text-black'}`}
            onClick={() => {
              onStepSelect(index, step);
            }}
          >
            {step.name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CustomStepper;